import { getApiUrl } from "../config/config";
const API_URL = getApiUrl()

export async function postData(url, data) {
       
    const response = await fetch(`${API_URL}${url}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    })
    return await response.json();
}

export async function getData(url) {
    
    const response = await fetch(`${API_URL}${url}`, 
    {
        method: 'GET'
    })
    return await response.json();
}

export async function putData(url, data) {
   
    const response = await fetch(`${API_URL}${url}`, {
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    })
    return await response.json();
}
